import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { MapPin, Wifi, Zap, Coffee, Monitor, Users } from 'lucide-react';

const FEATURE_ICONS = {
  'Wifi': Wifi,
  'Power Outlets': Zap,
  'Whiteboard': Monitor,
  'Cafe': Coffee,
  'Couches': Users, // Using Users as a proxy for social seating
  'FoodAndDrinks': Coffee,
  'privateDesks': Users,
  'accessible': Users, // Generalized
  'projector': Monitor
};

const Card = ({ spot }) => {
  const navigate = useNavigate();
  const [isLoaded, setIsLoaded] = useState(false);
  const features = Array.isArray(spot?.features) ? spot.features.slice(0, 3) : [];

  const handleClick = () => {
    navigate(`/listing/${spot.id}`);
  };

  return (
    <div 
      onClick={handleClick}
      className="group cursor-pointer flex flex-col gap-3"
    >
      {/* Image Container */}
      <div className="relative aspect-[4/3] rounded-2xl overflow-hidden bg-white/5">
        <img
          src={spot.imageURL?.[0] || '/buildings/default.jpg'}
          alt={spot.name}
          onLoad={() => setIsLoaded(true)}
          className={`w-full h-full object-cover transition-all duration-500 group-hover:scale-105 ${
            isLoaded ? 'opacity-100' : 'opacity-0'
          }`}
        />
        
        {/* Space Type Badge */}
        <div className="absolute top-3 left-3">
          <span className="px-3 py-1 rounded-full bg-black/50 backdrop-blur-md text-white text-xs font-medium border border-white/10">
            {spot.spaceType}
          </span>
        </div>
      </div>

      {/* Content */}
      <div>
        <div className="flex justify-between items-start mb-1">
          <h3 className="text-lg font-semibold text-white group-hover:text-purple-400 transition-colors line-clamp-1">
            {spot.name}
          </h3>
        </div>
        
        <div className="flex items-center text-gray-400 text-sm mb-3">
          <MapPin size={14} className="mr-1.5" />
          <span className="truncate">{spot.location}</span>
        </div>

        {/* Features Row */}
        <div className="flex gap-2">
          {features.map((feature, index) => {
            const Icon = FEATURE_ICONS[feature] || Users;
            return (
              <div 
                key={index}
                className="p-1.5 rounded-lg bg-white/5 text-gray-400"
                title={feature}
              >
                <Icon size={14} />
              </div>
            );
          })}
          {spot.features?.length > 3 && (
            <div className="p-1.5 rounded-lg bg-white/5 text-gray-400 text-xs flex items-center justify-center w-7 h-7">
              +{spot.features.length - 3}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Card;